__turbopack_context__.v({
  "carouselContainer": "SharedPrizeCarousel-module__Coh9Aq__carouselContainer",
  "carouselImageWrapper": "SharedPrizeCarousel-module__Coh9Aq__carouselImageWrapper",
  "carouselLinkContent": "SharedPrizeCarousel-module__Coh9Aq__carouselLinkContent",
  "carouselOverlay": "SharedPrizeCarousel-module__Coh9Aq__carouselOverlay",
  "carouselSlide": "SharedPrizeCarousel-module__Coh9Aq__carouselSlide",
  "carouselTextContent": "SharedPrizeCarousel-module__Coh9Aq__carouselTextContent",
  "itemSubheading": "SharedPrizeCarousel-module__Coh9Aq__itemSubheading",
  "overlayBottom": "SharedPrizeCarousel-module__Coh9Aq__overlayBottom",
  "overlayGradient": "SharedPrizeCarousel-module__Coh9Aq__overlayGradient",
  "overlaySolid": "SharedPrizeCarousel-module__Coh9Aq__overlaySolid",
  "prizeCarousel": "SharedPrizeCarousel-module__Coh9Aq__prizeCarousel",
});
